import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs/index';

export interface GetsFeatureBaseService {
  getAll(): Observable<Set<string>>;
}

export const GETS_FEATURE_FLAGS = new InjectionToken<GetsFeatureBaseService>('GETS_FEATURE_FLAGS');
